import { Builder } from '@builder.io/react';

import Header from './index';

Builder.registerComponent(Header, {
  name: 'Header',
  inputs: [
    {
      name: 'signupURL',
      type: 'string',
      helperText: 'Custom Log In link'
    },
    {
      name: 'demoMode',
      type: 'boolean',
      defaultValue: false,
      helperText: 'Enable to only show the Scale Logo'
    },
    {
      name: 'theme',
      type: 'string',
      enum: ['dark', 'light']
    },
    {
      name: 'background',
      type: 'string',
      enum: ['bg-transparent', 'bg-black', 'bg-white'],
      defaultValue: 'bg-transparent'
    }
  ]
});
